
export const LOGO_LEFT_INFO_RIGHT = 'LOGO_LEFT_INFO_RIGHT'
export const LOGO_INFO_CENTER = 'LOGO_INFO_CENTER'
export const LOGO_RIGHT_INFO_LEFT = 'LOGO_RIGHT_INFO_LEFT'